document.body.addEventListener("click", function (e) {
  const target = e.target.closest(".js-blog-next-page");
  if (target) {
    e.preventDefault();

    const href = target.getAttribute("data-href");
    const loadingText = target.getAttribute("data-loading-text");
    target.querySelector('span').innerHTML = loadingText;

    fetch(href)
      .then(response => response.text())
      .then(data => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;

        const blogAction = document.querySelector(".js-blog-action");
        if (blogAction) {
          blogAction.remove();
        }

        const newBlogContent = tempDiv.querySelector(".js-blog-row");
        const blogRow = document.querySelector(".js-blog-row");

        if (newBlogContent && blogRow) {
          blogRow.insertAdjacentHTML("beforeend", newBlogContent.innerHTML);
        }

        setTimeout(function () {
          applyMatchHeightPerRow("[data-match-height]");
          initializeObservers();
        }, 100);
      });
  }
});